/**
 * @author Nihar<nihar.baishya@314ecorp.com>
 * @description React Hook useBatchEligibilityRequestHistory
 */
import { useQuery, UseQueryResult } from '@tanstack/react-query';

import api from 'client/index';
import QUERY_KEYS from 'app-constants/queryKeys';
import { ELIGIBILITY_BATCH_UPLOAD_STATUS_CODES } from 'app-constants/eligibility';

/**
 * Paginated Batch Eligibility Requests History
 * @returns {UseQueryResult} useBatchEligibilityRequestHistory
 */

const useBatchEligibilityRequestHistory = (
	queryModel: EligibilityBatchUpload.IBatchEligibilityHistoryQueryModel,
	pageNumber?: number,
	pageSize?: number,
	options?: IQueryOptions,
): UseQueryResult<EligibilityBatchUpload.IBatchEligibilityRequests, unknown> => {
	return useQuery({
		queryKey: [QUERY_KEYS.batchEligibilityRequest, { queryModel, pageNumber, pageSize }],
		queryFn: async () => {
			const { data } = await api.EzapiApi.getBatchEligibilityRequests(queryModel, pageNumber, pageSize);
			return data;
		},
		refetchInterval: 1000 * 60 * 2, // 2 mins,
		...options,
	});
};

const IN_PROGRESS_QUERY_PARAMS: {
	filterParams: EligibilityBatchUpload.IBatchEligibilityHistoryQueryModel;
	pageNumber: number;
	pageSize: number;
} = {
	pageNumber: 1,
	pageSize: 1,
	filterParams: {
		status: [ELIGIBILITY_BATCH_UPLOAD_STATUS_CODES.inProgress, ELIGIBILITY_BATCH_UPLOAD_STATUS_CODES.scheduled],
	},
};

export { IN_PROGRESS_QUERY_PARAMS };
export default useBatchEligibilityRequestHistory;
